import React, { useEffect, useState } from "react";
import { useToast } from "hooks/useToast";
import { getPdfParams } from "utils/helper/localStorage";
import { getDownloadUrl } from "utils/helper/download";
import { isEmpty, valueFromKeyOrDefault } from "utils/helper/common";
import Viewer from "../viewer";

interface Props {
  hideDownloadButton?: boolean;
}

const DefaultViewer: React.FunctionComponent<Props> = ({
  hideDownloadButton = false
}) => {
  const [error, setError] = useState<string>("");
  const [url, setUrl] = useState<string>();
  const [keywords, setKeywords] = useState<string[]>([]);

  const toast = useToast();

  const getUrl = async () => {
    const { urlNumber, params, keywords } = getPdfParams();
    setKeywords(keywords);

    try {
      const tmpUrl = await getDownloadUrl(urlNumber, params, null);
      setUrl(tmpUrl);
    } catch (e) {
      if (e instanceof Error && e.message === "UNAUTHORIZED") {
        location.href = "/login";
      } else {
        const errorBody = (e as { body?: unknown }).body;
        const message = valueFromKeyOrDefault(
          typeof errorBody === "object" && errorBody !== null ? errorBody : {},
          "details.0.message",
          ""
        ) as string;
        toast.setErrors(message);
        setError(message);
      }
    }
  };

  useEffect(() => {
    getUrl();
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!isEmpty(error) || !url) return null;

  return (
    <Viewer
      src={url}
      keywords={keywords}
      visibleSaveButton={!hideDownloadButton}
    />
  );
};

export default DefaultViewer;
